import { createSelector } from "@reduxjs/toolkit";
import type { PostMcbimItemsApiResponse } from "../../openapi";
import { selectShowOnlyRoomSectionItemsVisibleIn2d } from "../DesignTab/designSlice";
import { selectMcBimItemsForViewer } from "../McBim/mcbimItemSelectors";
import { selectHttpMcBimCeilingItems } from "../McBim/httpMcBimSelectors";

type McBimItemIdentitySource = PostMcbimItemsApiResponse[number];

const selectActiveModule = (state: {
  design: { activeModule: string | undefined; deviceViewMode: string };
}) => state.design.activeModule;

const selectDeviceViewMode = (state: {
  design: { activeModule: string | undefined; deviceViewMode: string };
}) => state.design.deviceViewMode;

const addItemIdentity = (set: Set<string>, item: McBimItemIdentitySource) => {
  if (item._id != null) {
    set.add(String(item._id));
  }

  if (item.globalId) {
    set.add(item.globalId);
  }
};

export const selectRoomSectionVisible2dItemIdentitySet = createSelector(
  [
    selectShowOnlyRoomSectionItemsVisibleIn2d,
    selectMcBimItemsForViewer,
    selectHttpMcBimCeilingItems,
    selectActiveModule,
    selectDeviceViewMode,
  ],
  (
    showOnlyVisibleIn2d,
    mcbimItemsForViewer,
    ceilingItems,
    activeModule,
    deviceViewMode
  ): Set<string> | null => {
    if (!showOnlyVisibleIn2d) {
      return null;
    }

    const visibleItems =
      activeModule === "CEILING" && deviceViewMode === "ifc"
        ? [...mcbimItemsForViewer, ...ceilingItems]
        : mcbimItemsForViewer;

    const visibleIdentities = new Set<string>();
    visibleItems.forEach((item) => addItemIdentity(visibleIdentities, item));
    return visibleIdentities;
  }
);

